import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ComplainHttpService } from 'src/app/http/complain-http.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/services/account.service';

@Component({
    selector: 'app-complain-edit',
    templateUrl: './complain-edit.component.html',
    styles: [],
})
export class ComplainEditComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private complainHttpService: ComplainHttpService,
        private router: Router,
        public location: Location,
        private activatedRoute: ActivatedRoute,
        private sharedService: SharedService,
        private modalService: NgbModal,
        private accountService: AccountService
    ) {}

    editComplaintForm = this.fb.group(
        {
            complainsId: [null],
            branchId: [null, Validators.required],
            title: [null, Validators.required],
            subTitle: [null, Validators.required],
            customerName: [null, Validators.required],
            customerPhone: [null, Validators.required],
            description: [null, Validators.required],
            status: ['Open', Validators.required],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    complain: any;

    compliansTitles = this.sharedService.compliansTitles;

    compliansSubTitles = this.sharedService.compliansSubTitles;

    compliansStatus = this.sharedService.compliansStatus;

    compliansSubTitlesCurrent: any[] = [];

    compliansDetails: any[];

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branches = data.data[0];
            this.complain = data.data[1];
            this.compliansDetails = data.data[1].complainsDetails;
            this.patchForm(data.data[1]);
        });
    }

    onChange(ev: any) {
        this.compliansSubTitlesCurrent = this.compliansSubTitles.filter((c) => c.title === ev.value);
        this.editComplaintForm.controls['subTitle'].setValue(null);
    }

    patchForm(data: any) {
        this.editComplaintForm.patchValue(data);
        this.compliansSubTitlesCurrent = this.compliansSubTitles.filter((c) => c.title === data.title);
    }

    onSubmit() {
        this.editComplaintForm.markAsTouched();
        if (this.editComplaintForm.valid) {
            this.formBusy = true;
            const value = this.prepareForm(this.editComplaintForm.value);
            this.complainHttpService.editComplain(value).subscribe(
                () => {
                    this.router.navigateByUrl('/management/complain-list', {
                        state: { hasState: true, type: 'success', message: 'Complain Edited successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.editComplaintForm.setErrors({ exists: true });
                }
            );
        }
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this complain?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.complainHttpService.deleteComplain(item.complainsId).subscribe(() => {
            this.router.navigateByUrl('/management/complain-list', {
                state: { hasState: true, type: 'success', message: 'Complain Deleted successfully' },
            });
        });
    }

    prepareForm(data: any) {
        return {
            complainsId: data.complainsId,
            branchId: data.branchId,
            title: data.title,
            subTitle: data.subTitle,
            customerName: data.customerName,
            customerPhone: data.customerPhone,
            status: data.status,
            complainsDetails: [
                {
                    description: data.description,
                    status: data.status,
                },
            ],
        };
    }

    get isWhoCreatedCom() {
        return this.accountService.currentUser.id === this.complain.createdBy;
    }

    get isCanceledOrCompleted() {
        return this.complain.status === 'Canceled' || this.complain.status === 'Completed';
    }
}
